.container {
  display: flex;
  flex-wrap: wrap;
  margin: calc(-1 * var(--space-xs));
}

.isInline {
  display: inline-flex;
  flex-wrap: nowrap;
}
